import {PropertyBase} from "../PropertyBase";

export class GroupProperties{
    public  Properties:PropertyBase[]=[];
    public static id:number=0;

    constructor(public Label:string){


    }



    public AddProperty(property:PropertyBase){
        this.Properties.push(property);
        return this;
    }

    public AddProperties(properties:PropertyBase[])
    {
        for(let property of properties)
            if(property!=null)
                this.Properties.push(property);
        return this;
    }



}